import { portalApi } from '../../../api';
import { createErrorToast, createSuccessToast } from '../app';

const initialState = {
  currentInsuranceRequirement: null,
  currentInsuranceRequirementId: null,
  requirementLoading: false
};

const RESET_INSURANCE_REQUIREMENT = 'RESET_INSURANCE_REQUIREMENT';
export const resetInsuranceRequirement = () => dispatch => dispatch({ type: RESET_INSURANCE_REQUIREMENT });

const GET_INSURANCE_REQUIREMENT = 'GET_INSURANCE_REQUIREMENT';
const GET_INSURANCE_REQUIREMENT_SUCCESS = 'GET_INSURANCE_REQUIREMENT_SUCCESS';
const GET_INSURANCE_REQUIREMENT_FAILURE = 'GET_INSURANCE_REQUIREMENT_FAILURE';
export const getInsuranceRequirement = recordId => async dispatch => {
  dispatch({ type: GET_INSURANCE_REQUIREMENT, recordId });

  try {
    const response = await portalApi.getRecord(recordId);

    dispatch({ type: GET_INSURANCE_REQUIREMENT_SUCCESS, response });
  } catch (error) {
    dispatch({ type: GET_INSURANCE_REQUIREMENT_FAILURE, error });
  }
};

const UPDATE_INSURANCE_REQUIREMENT = 'UPDATE_INSURANCE_REQUIREMENT';
const UPDATE_INSURANCE_REQUIREMENT_SUCCESS = 'UPDATE_INSURANCE_REQUIREMENT_SUCCESS';
const UPDATE_INSURANCE_REQUIREMENT_FAILURE = 'UPDATE_INSURANCE_REQUIREMENT_FAILURE';
export const updateInsuranceRequirement = (recordId, updatedData) => async dispatch => {
  dispatch({ type: UPDATE_INSURANCE_REQUIREMENT, recordId, updatedData });

  try {
    const response = await portalApi.updateRecord(recordId, updatedData);

    dispatch({ type: UPDATE_INSURANCE_REQUIREMENT_SUCCESS, response });
    dispatch(createSuccessToast({ title: 'Record Information Successfully Updated' }));
  } catch (error) {
    dispatch({ type: UPDATE_INSURANCE_REQUIREMENT_FAILURE, error });

    dispatch(createErrorToast({
      title: 'Uh oh, something went wrong',
      description: error.message,
      error
    }));
  }
};

const SET_CURRENT_INSURANCE_REQUIREMENT = 'SET_CURRENT_INSURANCE_REQUIREMENT';
export const setCurrentInsuranceRequirement = requirementId => async dispatch => {
  dispatch({ type: SET_CURRENT_INSURANCE_REQUIREMENT, requirementId });
};

const insuranceRequirementReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_INSURANCE_REQUIREMENT:
      return { ...state, requirementLoading: true };

    case GET_INSURANCE_REQUIREMENT_SUCCESS:
      return {
        ...state,
        currentInsuranceRequirementId: action.response.id,
        currentInsuranceRequirement: action.response,
        requirementLoading: false
      };

    case GET_INSURANCE_REQUIREMENT_FAILURE:
      return { ...state, error: action.error, requirementLoading: false };

    case UPDATE_INSURANCE_REQUIREMENT:
      return { ...state, requirementLoading: true };

    case UPDATE_INSURANCE_REQUIREMENT_SUCCESS:
      return {
        ...state,
        currentInsuranceRequirement: action.response,
        requirementLoading: false
      };

    case UPDATE_INSURANCE_REQUIREMENT_FAILURE:
      return { ...state, error: action.error, requirementLoading: false };

    case SET_CURRENT_INSURANCE_REQUIREMENT:
      return { ...state, currentInsuranceRequirementId: action.requirementId };

    case RESET_INSURANCE_REQUIREMENT:
      return initialState;

    default:
      return state;
  }
};

export const selectCurrentRequirement = state => state.insuranceRequirements.currentInsuranceRequirement;

export default insuranceRequirementReducer;
